import React from "react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { CalendarDays } from "lucide-react";

/**
 * Cross-browser date field. Native <input type="date"> has NO calendar popup
 * in desktop Safari (text-only entry), which broke the custom date filter for
 * Safari users — this popover calendar works identically in every browser.
 * Value format: "YYYY-MM-DD" (same as native inputs, drop-in replacement).
 */
export function DateField({ value, onChange, testid, placeholder = "Pick a date", className = "", max = null }) {
  const [open, setOpen] = React.useState(false);
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={`flex items-center gap-1.5 h-8 px-2.5 rounded-md border border-slate-200 bg-white font-mono text-xs text-left transition-colors hover:border-slate-300 whitespace-nowrap ${
            selected ? "text-slate-800" : "text-slate-400"
          } ${className}`}
        >
          <CalendarDays size={12} className="text-pink-500 shrink-0" />
          {selected
            ? selected.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })
            : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white border-slate-200 shadow-xl" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            if (d) {
              const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
              onChange(iso);
            }
            setOpen(false);
          }}
          disabled={max ? { after: new Date(max + "T00:00:00") } : undefined}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
